import { useContext } from 'react'

import { AppQuiz_content_QuizContent_questions } from 'globalTypes'

import { Disclosure } from '@headlessui/react'
import Button from 'Root/App/Button'
import { Context as UsageContext } from 'Root/App/Contexts/Usage'
import map from 'lodash/map'

import Answer from './Answer'
import styles from './index.module.css'

interface Answers {
  [id: string]: any
}

interface Props {
  answers: Answers
  questions: AppQuiz_content_QuizContent_questions[]
}

const Recap = ({ answers, questions }: Props) => {
  const useCase = useContext(UsageContext)

  if (useCase === 'card') {
    return null
  }

  return (
    <Disclosure>
      <Disclosure.Button as={Button} className={styles.button} size="S">
        Visualizza Risposte
      </Disclosure.Button>
      <Disclosure.Panel className={styles.list} role="list">
        {map(questions, (question, index) => (
          <div className={styles.listitem} role="listitem">
            <div>
              <span className="font-medium">Domanda #{index + 1}</span>
              {question.__typename !== 'QuizContentQuestionMissingWord' && (
                <span>: {question.title}</span>
              )}
            </div>
            <Answer answer={answers?.[question.id]} question={question} />
          </div>
        ))}
      </Disclosure.Panel>
    </Disclosure>
  )
}

export default Recap
